class wheel extends HTMLElement {
  constructor() {
    super();
  }

  getCart() {
    return (
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer")
    );
  }

  setPendingCartRender(cartData) {
    this._pendingCartData = cartData;
  }

  flushPendingCartRender() {
    if (!this._pendingCartData) return;

    const cart = this.getCart();
    if (cart?.renderContents && this._pendingCartData.sections) {
      cart.renderContents(this._pendingCartData);
    }
    this._pendingCartData = null;
  }

  getCartSectionsPayload() {
    const cart = this.getCart();
    if (!cart?.getSectionsToRender) {
      return {};
    }

    return {
      sections: cart
        .getSectionsToRender()
        .map((section) => section.section),
      sections_url: window.location.pathname,
    };
  }

  async connectedCallback() {
    this.wheelWrapper = this.querySelector(".wheel-wrapper");
    this.wheel = this.querySelector(".wheel #discount-wheel");
    this.pointer = this.querySelector(".pointer-wrapper");
    this.prizes = this.wheel.querySelectorAll("[data-product-id]");
    this.spinning = false;
    this.normalText = this.querySelector(".normal-text");
    this.successText = this.querySelector(".success-text");
    this.addToCartButton = document.querySelector("product-info .product-form__buttons button[name='add']");
    this.threshold = this.getAttribute('data-threshold');

    this._wheelDebounceTimer = null;
    this._pendingCartData = null;
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (this.spinning) return;
      clearTimeout(this._wheelDebounceTimer);
      this._wheelDebounceTimer = setTimeout(() => this.startWheel(false, event?.cartData), 300);
    });
    this.addToCartButton?.addEventListener("click", () => {
      if (!this.addToCartButton.classList.contains("hidden")) {
        setTimeout(() => void this.startWheel(true), 400);
      }
    });
    document.addEventListener("click", (event) => {
      if (
        !event.target.closest(".wheel-tiers-wrapper") &&
        !this.spinning &&
        this.classList.contains("active")
      ) {
        this.closeWheel();
      }
    });
  }

  async startWheel(bypass = false, cartData = null) {
    if (this.spinning) return;

    const cartPromise = (cartData && cartData.total_price !== undefined && Array.isArray(cartData.items))
      ? Promise.resolve(cartData)
      : fetch("/cart.js").then((response) => response.json());

    await cartPromise.then(async (cart) => {
        const hasPrize = cart.items.some(
          (item) => (item.properties._juneSpinTheWheel === "true" || item.properties['_Reward Threshold'] !== undefined)
        );
        const cartTotal = cart.total_price;
        if ((cartTotal >= this.threshold && !hasPrize && document.querySelectorAll('.spin-the-wheel-product').length > 0 && document.querySelectorAll('[no-wheel-packs]').length == 0) || (bypass == true && !hasPrize && document.querySelectorAll('[no-wheel-packs]').length == 0)) {
          this.spinning = true;
          this.classList.add("is-spinning");
          let response = await this.spinWheel();

          const prize = response.prize;
          const productId = prize.getAttribute("data-product-id");

          await fetch(`/cart/add.js`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              id: productId,
              quantity: 1,
              properties: {
                _juneSpinTheWheel: "true",
                '_Reward Threshold': `${this.threshold / 100}`,
                Includes: "All Unreleased Products",
              },
              ...this.getCartSectionsPayload(),
            }),
          })
            .then((response) => response.json())
            .then((data) => {
              this.celebrate();
              setTimeout(() => {
                this.closeWheel();
              }, 4000);
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'cart-drawer',
                cartData: data,
              });
            })
            .catch((error) => {
              console.error("Error adding product to cart:", error);
            });
        } else if (
          cartTotal < this.threshold &&
          hasPrize
        ) {
          let gifts = cart.items.filter((item) => {
            return item.properties._juneSpinTheWheel === "true";
          });
          let updates = gifts.reduce((obj, item) => {
            obj[item.id] = 0;
            return obj;
          }, {});

          await fetch(`/cart/update.js`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              updates,
              ...this.getCartSectionsPayload(),
            }),
          })
            .then((response) => response.json())
            .then((data) => {
              setTimeout(() => {
                this.closeWheel();
              }, 4000);
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'cart-drawer',
                cartData: data,
              });
            })
            .catch((error) => {
              console.error("Error removing product from cart:", error);
            });
        }
      });
  }

  async spinWheel() {
    this.normalText.style.display = "block";
    this.successText.style.display = "none";
    this.style.display = "block";

    setTimeout(() => {
      this.classList.add("active");
    }, 100);

    const refreshRate = await this.getScreenRefreshRate();

    // Total spin time is kept within 4–7 s:
    //   fast-spin phase: random 1–4 s
    //   slowdown phase:  fixed ~3 s (derived below)
    const slowdownSeconds = 3;
    const spinDuration = Math.floor(Math.random() * (3000 + 1)) + 1000; // 1000–4000 ms
    const initialSpeed = 10; // degrees per frame
    const stopThreshold = 0.05; // speed at which the wheel is considered stopped

    // Derive the decay so the slowdown always lasts ~slowdownSeconds,
    // independent of the display's refresh rate.
    const slowdownFactor = Math.pow(
      stopThreshold / initialSpeed,
      1 / (slowdownSeconds * refreshRate)
    );

    // Calculate theoretical time to stop (when speed drops below stopThreshold)
    const framesUntilStop =
      Math.log(stopThreshold / initialSpeed) / Math.log(slowdownFactor);
    const estimatedSlowdownTime = framesUntilStop * (1000 / refreshRate);
    const totalEstimatedTime = spinDuration + estimatedSlowdownTime;

    let currentSpeed = initialSpeed;
    let currentRotation = 0;
    let startTime = performance.now();
    let timeElapsed = 0;

    const currentTime = performance.now();
    const timeRemaining = Math.max(
      0,
      totalEstimatedTime - (currentTime - startTime)
    );

    this.querySelector(".spin-time-remaining").innerHTML = `${Math.floor(
      timeRemaining / 1000
    )} seconds`;
    const intervalId = setInterval(() => {
      const currentTime = performance.now();
      const timeRemaining = Math.max(
        0,
        totalEstimatedTime - (currentTime - startTime)
      );
      if (timeRemaining <= 0) {
        this.normalText.style.display = "none";
        clearInterval(intervalId);
      }
      this.querySelector(".spin-time-remaining").innerHTML = `${Math.floor(
        timeRemaining / 1000
      )} seconds`;
    }, 1000);

    return new Promise((resolve) => {
      const animate = (currentTime) => {
        timeElapsed = currentTime - startTime;

        if (timeElapsed < spinDuration) {
          // Continue at full speed until we reach the slowdown point
          currentRotation += currentSpeed;
          this.wheel.style.transform = `rotate(${currentRotation}deg)`;
          requestAnimationFrame(animate);
        } else if (currentSpeed > 0.05) {
          // Start slowing down
          currentSpeed *= slowdownFactor;
          currentRotation += currentSpeed;
          this.wheel.style.transform = `rotate(${currentRotation}deg)`;
          requestAnimationFrame(animate);
        } else {
          // Stop the wheel
          this.wheel.style.transform = `rotate(${currentRotation}deg)`;

          const actualTotalTime = (performance.now() - startTime) / 1000;

          const finalRotation = currentRotation % 360;
          const numberOfPrizes = 8;
          const segmentSize = 360 / numberOfPrizes;
          // Convert to positive value if negative
          if (finalRotation < 0) finalRotation += 360;
          const prizeIndex = Math.round(finalRotation / segmentSize);
          let selectedPrize = numberOfPrizes - prizeIndex;

          if (selectedPrize == numberOfPrizes) {
            selectedPrize = 0;
          }
          let prize = this.prizes[selectedPrize];    
          if(prize.getAttribute("data-product-id") === ""){
            while (prize.getAttribute("data-product-id") === "") {
              if (selectedPrize <= 0) {
                selectedPrize = 8;
              }
              selectedPrize--;
              prize = this.prizes[selectedPrize];
            }
          }
          const prizeTitle =
            prize.getAttribute("data-product-title") || "Prize";

          const successText = this.querySelector(".prize-product-title");
          this.querySelector(".success-text").style.display = "block";
          this.querySelector(".normal-text").style.display = "none";
          const bottomText = this.querySelector(".wheel-success-text.bottom-text");
          if(bottomText){
            bottomText.style.display = "block";
          }
          if (successText) {
            successText.innerHTML = prizeTitle;
          }

          resolve({
            prize,
          });
        }
      };

      requestAnimationFrame(animate);
    });
  }

  celebrate() {
    var end = Date.now() + 4.5 * 1000;

    var colors = ["#710607", "#ffffff", "#E1223C"];
    let zIndex = 2147483647;

    (function frame() {
      confetti({
        particleCount: 3,
        angle: 60,
        spread: 70,
        origin: { x: 0 },
        colors: colors,
        zIndex: zIndex,
      });
      confetti({
        particleCount: 3,
        angle: 120,
        spread: 70,
        origin: { x: 1 },
        colors: colors,
        zIndex: zIndex,
      });

      if (Date.now() < end) {
        requestAnimationFrame(frame);
      }
    })();
  }

  closeWheel() {
    this.classList.remove("active");
    setTimeout(() => {
      this.style.display = "none";
      this.wheel.style.transform = "rotate(0deg)";
      this.classList.remove("is-spinning");
      this.flushPendingCartRender();
    }, 500);
    this.spinning = false;

    this.querySelector(".success-text").style.display = "none";
    this.querySelector(".normal-text").style.display = "block";
    const bottomText = this.querySelector(".wheel-success-text.bottom-text");
    if(bottomText){
      bottomText.style.display = "none";
    }
    const successText = this.querySelector(".wheel-success-text").querySelector(
      ".prize-product-title"
    );
    if (successText) {
      successText.innerHTML = "";
    }
  }

  getScreenRefreshRate() {
    return new Promise((resolve) => {
      // Try to use the Screen Refresh Rate API if available
      if (window.screen && window.screen.requestVideoFrameCallback) {
        // Modern approach using newer APIs when available
        let videoElement = document.createElement("video");
        let frameCallbacks = 0;
        let startTime;

        const frameCallback = (time) => {
          if (!startTime) startTime = time;
          frameCallbacks++;

          if (time - startTime < 1000) {
            // Measure for 1 second
            videoElement.requestVideoFrameCallback(frameCallback);
          } else {
            const fps = Math.round(
              (frameCallbacks * 1000) / (time - startTime)
            );
            videoElement = null;
            resolve(fps);
          }
        };

        videoElement.requestVideoFrameCallback(frameCallback);
      } else {
        // Fallback to traditional rAF with multiple measurements
        const measurements = [];
        let frames = 0;
        let lastTimestamp;

        const measureFrameRate = (timestamp) => {
          if (lastTimestamp) {
            const frameDuration = timestamp - lastTimestamp;
            if (frameDuration > 0) {
              measurements.push(1000 / frameDuration); // fps for this frame
            }
          }

          lastTimestamp = timestamp;
          frames++;

          if (frames < 120) {
            // Collect more samples (2 seconds at 60fps)
            requestAnimationFrame(measureFrameRate);
          } else {
            // Remove outliers (lowest and highest 10%)
            measurements.sort((a, b) => a - b);
            const trimAmount = Math.floor(measurements.length * 0.1);
            const trimmedMeasurements = measurements.slice(
              trimAmount,
              measurements.length - trimAmount
            );

            // Average the middle 80%
            const sum = trimmedMeasurements.reduce((acc, val) => acc + val, 0);
            const fps = Math.round(sum / trimmedMeasurements.length);

            // Apply common refresh rate correction
            const standardRates = [30, 60, 90, 120, 144, 240];
            const closestRate = standardRates.reduce((prev, curr) =>
              Math.abs(curr - fps) < Math.abs(prev - fps) ? curr : prev
            );

            // If we're within 10% of a standard rate, use that instead
            const finalRate =
              Math.abs(fps - closestRate) < closestRate * 0.1
                ? closestRate
                : fps;

            resolve(finalRate);
          }
        };

        requestAnimationFrame(measureFrameRate);
      }
    });
  }
}
customElements.define("wheel-element", wheel);
